import Page from "../Page";
import React, { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Session from "../../../services/Session";
import Signals from "../../../signals/Signals";
import LogoutCommand from "../../../commands/authentication/LogoutCommand";
import UnregisterUserCommand from "../../../commands/users/UnregisterUserCommand";
export default injectIntl(function UnregisterUser(props) {
    var _a = useState(""), username = _a[0], setUsername = _a[1];
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    var usernameNotValid = Session.user.email.toLowerCase() !== (username === null || username === void 0 ? void 0 : username.toLowerCase());
    function handleUserUnregistered(response) {
        Signals.ShowNotification.dispatch(props.intl.formatMessage({ id: "page.unregisterUser.notification.success" }), "dark", true);
        var command = new LogoutCommand();
        command.execute();
    }
    function handleUnregisterError(error) {
        Signals.ShowNotification.dispatch(props.intl.formatMessage({ id: "error.unregisterUser" }), 'danger');
    }
    var unregisterUser = function (e) {
        var command = new UnregisterUserCommand();
        command.execute(username).then(handleUserUnregistered)
            .catch(handleUnregisterError);
    };
    return React.createElement(Page, { pageName: "unregisterUser-account" },
        React.createElement("div", { className: "h-100 pb-4" },
            React.createElement("div", { className: "card mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                React.createElement("div", { className: "card-header flex-grow-0 pb-0" },
                    React.createElement("div", { className: "d-flex justify-content-between mb-4 pr-3 flex-wrap" },
                        React.createElement("h1", { className: 'header-title align-self-center order-0 mr-3' },
                            React.createElement(FormattedMessage, { id: "page.unregisterUser.title" })))),
                React.createElement("div", { className: "card-body pt-0 mr-4 pr-0 overflow-auto" },
                    React.createElement(Button, { color: "danger", onClick: function () { return setShowModal(true); } },
                        React.createElement(FormattedMessage, { id: "page.unregisterUser.deleteaccount" })))),
            React.createElement(Modal, { isOpen: showModal },
                React.createElement(ModalHeader, { toggle: function () { return setShowModal(false); } },
                    React.createElement("h4", null,
                        React.createElement(FormattedMessage, { id: "page.unregisterUser.modal.title" }))),
                React.createElement(ModalBody, null,
                    React.createElement("div", { className: "mb-3" },
                        React.createElement(FormattedMessage, { id: "page.unregisterUser.modal.body" }),
                        React.createElement("strong", null,
                            React.createElement(FormattedMessage, { id: "page.unregisterUser.modal.body.warning" }))),
                    React.createElement("label", null,
                        React.createElement(FormattedMessage, { id: "page.unregisterUser.field.username" })),
                    React.createElement(Input, { value: username, onChange: function (e) { return setUsername(e.target.value); } })),
                React.createElement(ModalFooter, null,
                    React.createElement(Button, { color: "outline-primary", onClick: function (e) {
                            setShowModal(false);
                            setUsername("");
                        } },
                        React.createElement(FormattedMessage, { id: "page.unregisterUser.modal.cancel" })),
                    React.createElement(Button, { color: "danger", disabled: usernameNotValid, onClick: unregisterUser },
                        React.createElement(FormattedMessage, { id: "page.unregisterUser.deleteaccount" }))))));
});
